<!--suppress ALL -->

<template>
  <div>

    <div v-if="loading" style="margin-bottom: 20px">
      <div size="large" style = "display: flex; margin-bottom: 15px">
        <img src="@/assets/loading.gif" width="300px">
<!--        <div style="margin-top: 50px; margin-left: 0px">正在生成中...</div>-->

<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
<!--        <Spin size="large" style = "margin-left: 5px" />-->
      </div>
    </div>



  </div>
</template>


<script>

  export default {
    name: 'Loading',
    data () {
      return {
        loading: false,
      }
    },

    methods: {

      show: function () {
        this.loading = true;
      },
      dismiss: function () {
        this.loading = false;
      },
    }

  }
</script>
